<template>
  <div class="c-bg--gray--pc c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
        <TheTemplateH
          v-if="investedData.invested_details"
          heading="ポイント詳細"
        >
          <template #title>付与基準達成</template>
          <template #header-label>
            <SmallText>
              {{ investedId.label }}&ensp;{{ investedId.id }}</SmallText
            >
          </template>
          <template #contents>
            <div class="p-the-h03">
              <TheHDetail
                :image="true"
                :rounded-image="true"
                :usage-point="usagePoint"
                :max-width="false"
              >
                <template #image>
                  <IconInvestedRounded
                    :icon-size="iconSize"
                    :bg-color="colorCode"
                    icon-color="#ffffff"
                    :type="investedDetails.image_type"
                  />
                </template>
                <template #header>
                  <div class="p-the-granted-detail">
                    <SmallText>
                      {{ investedDetails.investment_criteria_id.label }}&ensp;{{
                        investedDetails.investment_criteria_id.id
                      }}
                    </SmallText>

                    <HContainer margin-size="xs">
                      <template #content>
                        <span class="p-the-granted-detail__text" data-translate-skip>
                          {{ investedDetails.invested_name }}
                        </span>
                      </template>
                    </HContainer>
                  </div>
                </template>

                <template #body>
                  <HContainer>
                    <template #content>
                      <SmallText>摘要</SmallText>
                      <span class="p-the-h03__text" data-translate-skip>
                        {{ investedDetails.description }}
                      </span>
                    </template>
                  </HContainer>

                  <HContainer>
                    <template #content>
                      <HSpecColumnList
                        :list-item="columnList"
                        column-size="m"
                      />
                    </template>
                  </HContainer>
                </template>

                <template #label>
                  <TextLabel
                    v-if="point.label"
                    :color="{ border: '#9e9e9e', content: '#ffffff' }"
                    :reverse="true"
                  >
                    {{ point.label }}
                  </TextLabel>
                </template>

                <template v-if="point.expiration" #point>
                  <SmallText
                    v-for="({ label, date }, key) in point.expiration"
                    :key="key"
                    >{{ label }}&ensp;{{
                      date == "Invalid Date" ? "--" : date
                    }}</SmallText
                  >
                </template>
              </TheHDetail>
            </div>
          </template>
        </TheTemplateH>
      </div>
    </div>
    <FloatingGivePointButton />
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import TheHDetail from "@/general/components/pages/parts/PointHistoryList/layout/TheHDetail.vue";
import TheTemplateH from "@/general/components/templates/TheTemplateH.vue";
import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HSpecColumnList from "@/general/components/pages/parts/PointHistoryList/HSpecColumnList.vue";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { formatUTCDate } from "@/common/assets/js/utils/dateFormat";
import { getThanksOnlyPointName } from "@/common/assets/js/utils/pointName";
import { getGrantedPointsDetails } from "@/general/store/api";
import CONST_DATA from "@/general/mixins/const/constData";
import loginInfo from "@/general/store/modules/loginInfo";
import AuthApi from "@/general/api/authApi";
import auth from "@/general/store/modules/auth";
import {
  getQueryString,
  setQueryString
} from "@/common/assets/js/utils/queryParams";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";
import { mapState } from "vuex";

@Options({
  components: {
    TheHeader,
    TheFooter,
    TheBreadcrumb,
    TheHDetail,
    IconInvestedRounded,
    TextLabel,
    SmallText,
    TheTemplateH,
    HContainer,
    HSpecColumnList
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class PointHistoryGrantedInfo extends Vue {
  ssoFlg = false;
  investedData: any = {};
  userInfo: any = {};
  grantType: number;
  declare $refs: {
    theHeader: TheHeader;
  };
  storeColorCode: string;

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return this.storeColorCode;
  }

  get isSpScreenWidth() {
    return globals?.isSpScreenWidth;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }


  async setPageData() {
    const breadcrumb = [
      {
        text: "",
        url: CONST_DATA.SITE_MAP.TOP_PAGE,
        pageType: "home"
      },
      {
        text: "ポイント確認",
        url: `${CONST_DATA.SITE_MAP.POINT_CONFIRMATION}?${getQueryString({
          ...this.params,
          id: undefined
        })}`,
        pageType: "lower"
      },
      {
        text: "ポイント詳細",
        url: "",
        pageType: "lower"
      }
    ];

    await commons.getBreadcrumb(breadcrumb);
  }

  params = {
    id: "",
    transaction_type: "",
    transaction_direction: "",
    filter_position: "",
    refine_position: "",
    ordering: "",
    page: "1",
    search: ""
  };

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queries = [
      { k: "id" },
      { k: "transaction_type" },
      { k: "transaction_direction" },
      { k: "filter_position" },
      { k: "refine_position" },
      { k: "ordering", v: "-created_at" },
      { k: "page", v: 1 },
      { k: "search" }
    ];
    this.params = setQueryString(this.params, queries);
    await this.setPageData();

    this.userInfo = this.getUserDetails();
    await this.retrieveGrantPointDetails(parseInt(this.params.id, 10));
  }

  getUserDetails() {
    return JSON.parse(LocalStorage.getItem("userDetails") as string);
  }

  async retrieveGrantPointDetails(id: number) {
    const grantedPointsDetails = await getGrantedPointsDetails(id);

    if (
      typeof grantedPointsDetails === "undefined" ||
      grantedPointsDetails.status == "400"
    ) {
      if (this.ssoFlg) {
        // SSOログイン時は行き止まりエラー画面へ
        window.location.href = "/session-time-out/";
      } else {
        LocalStorage.removeAll();
        AuthApi.getLogout();
        auth.remove();
        window.location.href = "/system-error";
      }
    }

    const point = {
      usage: grantedPointsDetails?.points,
      sign: true,
      label: "",
      expiration: [
        {
          label: "有効期限",
          date: this.$dayjs
            .utc(grantedPointsDetails?.expires_at)
            .format("YYYY/MM/DD")
        }
      ]
    };

    if (grantedPointsDetails?.grant_type === 30) {
      point.label = this.thanksOnlyPointName;
      point.expiration.push({
        label: "贈与期限",
        date: this.$dayjs
          .utc(grantedPointsDetails?.thanks_exclusive_deadline)
          .format("YYYY/MM/DD")
      });
    }
    const invested_details = {
      image_type: grantedPointsDetails.image_type,
      investment_criteria_id: {
        label: "付与基準ID",
        id:
          grantedPointsDetails?.criteria_id == 0
            ? ""
            : grantedPointsDetails?.criteria_id
      },
      invested_name: grantedPointsDetails.title,
      description: grantedPointsDetails.text,
      date: this.$dayjs
        .utc(grantedPointsDetails?.authorize_date)
        .format("YYYY/MM/DD")
      //Ph3.0 使用していないためコメントアウト
      //sender_name:
      //  grantedPointsDetails.user_name != null
      //    ? grantedPointsDetails.user_name + "さん"
      //    : "－ さん",
      //sender_group:
      //  grantedPointsDetails.group_name != null
      //    ? grantedPointsDetails.group_name
      //    : "－"
    };

    if (grantedPointsDetails) {
      this.investedData = {
        title: grantedPointsDetails.title, // "付与基準達成",
        invested_id: {
          label: "付与ID",
          id: grantedPointsDetails?.id
        },
        invested_details,
        point
      };
      this.grantType = grantedPointsDetails.grant_type;
    } else {
      this.investedData = {};
    }
  }

  get columnList() {
    const investedDetails = this.investedData.invested_details;
    const columnList = [
      {
        label: "付与日",
        detail: [investedDetails.date]
      }
    ];
    return columnList;
  }

  public get fromKenkoPoint(): boolean {
    return this.grantType === 20 ? true : false;
  }

  get title() {
    return this.investedData.title; // "付与基準達成";
  }

  get investedId() {
    return this.investedData ? this.investedData.invested_id : {};
  }
  get investedDetails() {
    return this.investedData.invested_details;
  }
  get point() {
    return this.investedData && this.investedData.point
      ? this.investedData.point
      : {};
  }
  get usagePoint() {
    return this.investedData && this.investedData.point
      ? {
          point: this.investedData.point.usage,
          sign: this.investedData.point.sign
        }
      : {};
  }

  get iconSize() {
    return this.isSpScreenWidth ? 72 : 135;
  }

  get thanksOnlyPointName() {
    return getThanksOnlyPointName(
      CONST_DATA.POINT_NAME.THANKS_ONLY_POINT_DEFAULT_NAME2
    );
  }
}
</script>

<style lang="scss" scoped>
// DX_IC-723 フォントデザインが仕様のように合わせていく
.p-the-granted-detail {
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  &__text {
    @include pc {
      font-size: rem(20);
    }
    @include sp {
      font-size: rem(16);
    }
    display: block;
    line-height: 1.6;
    font-weight: bold;
  }
}

.p-the-h03__text {
  word-break: break-all;
}
</style>
